<template>
    <div ref="vSelectCustomRef" :class="classNames">
        <slot v-if="this.icon" name="icon"></slot>
        <slot></slot>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: "VSelectCustom",
    props: {
        dividerOutlined: Boolean,
        filled: Boolean,
        contained: Boolean,
        transparent: Boolean,
        color: String,
        icon: String,

        bordered: Boolean,
    },
    data() {
        const _color = this.$props.color ? this.$props.color : "primary"
        return {
            classNames: {
                "v-select-custom": true,
                "v-select-custom--filled": this.filled,
                "v-select-custom--contained": this.contained,
                "v-select-custom--transparent": this.transparent,
                "v-select-custom--dvider-outlined": this.dividerOutlined,
                "v-select-custom--style-bordered": this.bordered,
                [`v-select-custom--${_color}`]: true,
            },
        };
    },

    methods: {
        /**
         * @description Listen resize action of user to calculate maxWidth of label select
         * @since 2021.11.18
         */
        onListenResize() {
            const currentSelectEl = this.$el;
            if(currentSelectEl) {
                const label = currentSelectEl.querySelector(".vs__selected");
            
                // 36px = last icon, 30 = spacing seperate
                label && (label.style.maxWidth = `${currentSelectEl.clientWidth - 36 - 30}px`);
            }
        }
    },

    mounted() {
        // default listen 
        this.onListenResize();

        window.addEventListener("resize",  _.debounce(this.onListenResize, 10));
    },

    destroyed() {
        window.removeEventListener("resize",  _.debounce(this.onListenResize, 10));
    }
};
</script>

<style lang="scss" scope>

@import "@sass/vuexy/_variables.scss";

.v-select-custom {

    ul[role="listbox"], .vs__dropdown-menu {
        border-radius: 6px;
        border-width: 0;
        padding: 0;
        margin-top: 8px;

        li {
            padding-top: 10px;
            padding-bottom: 10px;
            color: var(--vs-hex-white);
        }
    }

    &.v-select-custom--filled {
        .v-select {
            background-color: rgba(var(--vs-danger), 0.12);
            border-radius: 5px;

            .vs__dropdown-toggle {
                border: 1px solid transparent;
                text-align: center;
                padding-top: 0.4rem !important;
                padding-bottom: 0.4rem !important;

                .vs__selected-options {
                    .vs__selected {
                        color: rgba(var(--vs-primary), 1);
                        font-weight: 500;
                    }
                }

                .vs__actions {
                    .vs__clear {
                        color: rgba(var(--vs-primary), 1);
                        font-weight: 500;
                    }

                    .vs__open-indicator {
                        color: rgba(var(--vs-primary), 1);
                        font-weight: 500;
                    }
                }
            }
        }
    }

    &.v-select-custom--dvider-outlined {
        position: relative;

        & > svg, i, & > .feather-icon {
            position: absolute !important;
            top: 50%;
            left: 10px;
            transform: translateY(-50%);
            color: var(--vs-hex-primary);

            & > path {
                fill: var(--vs-hex-primary);
            }

            & ~ .v-select {
                .vs__dropdown-toggle {
                    .vs__selected-options {
                        .vs__selected {
                            margin-left: 24px;
                        }
                    }
                }
            }
        }

        .v-select {
            .vs__dropdown-toggle {
                padding: 0;
                height: 38px;
                border-color: #d8d6de !important;

                .vs__selected-options {
                    .vs__selected {
                        white-space: nowrap;
                        // max-width: 150px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-top: 4px;
                        display: block;
                    }

                    .vs__search {
                        padding-left: 30px;
                    }
                }

                .vs__actions {
                    border-left: 1px solid rgba(var(--vs-dark), 0.3);
                    padding: 8px;
                    height: 100%;

                    .vs__clear {
                    }

                    .vs__open-indicator {
                        color: var(--vs-hex-primary);
                        cursor: pointer;
                    }
                }
            }
        }
    }

    @each $type, $hex in $colors {
        &.v-select-custom--#{$type}.v-select-custom--transparent {
            .v-select {
                .vs__dropdown-toggle {

                }
            }

            .vs-input--label {
                color: $hex !important;
            }
        }
    }
    
    @each $type, $hexMap in $colorsContained {
        &.v-select-custom--#{$type}.v-select-custom--contained {
            .v-select {
                background-color: map-get($map: $hexMap, $key: "color");
                border-radius: 5px;

                &.vs--open {
                    border-color: $primary !important;
                }

                .vs__dropdown-toggle {
                    border: 1px solid transparent;
                    text-align: center;
                    padding-top: 0.4rem !important;
                    padding-bottom: 0.4rem !important;

                    .vs__selected-options {
                        .vs__selected {
                            color: map-get($map: $hexMap, $key: "text");
                            font-weight: 500;
                        }
                    }

                    .vs__actions {
                        .vs__clear {
                            color: map-get($map: $hexMap, $key: "text");
                            font-weight: 500;
                        }

                        .vs__open-indicator {
                            color: map-get($map: $hexMap, $key: "text");
                            font-weight: 500;
                        }
                    }
                }
            }

            .vs-input--label {
                color: map-get($map: $hexMap, $key: "text") !important;
                font-size: 14px;
                font-weight: 400;
            }
            &.v-select-custom--style-bordered {
                .v-select {
                    border: 1px solid map-get($map: $hexMap, $key: "text");
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/VSelectCustom.vue